export const FILTER_PALMS_TRANSACTIONS = "FILTER_PALMS_TRANSACTIONS";
